import { z } from 'zod';
import { BaseEventSchema } from './Base';

export enum ProductInteractionLocation {
  HomeLoggedInCategories = 'home_logged_in_categories',
  HomeLoggedOutCategories = 'home_logged_out_categories',
  ProductView = 'product_view',
  ProductCard = 'product_card',
  LastWhim = 'last_whim',
  Cart = 'cart',
  LastPurchases = 'last_purchases',
  RelatedProducts = 'related_products',
  SearchResults = 'search_results',
  Categories = 'categories',
  Subcategories = 'subcategories',
  Pillbox = 'pillbox',
  PreviousOrdes = 'previous_orders',
}

export const ProductAddToCartSchema = BaseEventSchema.extend({
  product_id: z.number(),
  product_name: z.string(),
  product_price: z.number(),
  product_quantity: z.number(),
  product_prescription_type: z.string().nullable(),
  product_brand: z.string().optional(),
  product_availability: z.string(),
  access: z.nativeEnum(ProductInteractionLocation),
  product_index_position: z.number().nullable(),
  last_whim_type: z.string().nullable(),
  last_whim_index: z.number().nullable(),
});

export const ProductRemoveFromCartSchema = BaseEventSchema.extend({
  product_id: z.number(),
  product_name: z.string(),
  product_price: z.number(),
  product_quantity: z.number(),
  product_prescription_type: z.string().nullable(),
  product_brand: z.string().optional(),
  product_availability: z.string(),
  access: z.nativeEnum(ProductInteractionLocation),
  product_index_position: z.number().nullable(),
  last_whim_type: z.string().nullable(),
  last_whim_index: z.number().nullable(),
});

export enum ProductEventType {
  ProductAddToCart = 'product.add_to_cart',
  ProductRemoveFromCart = 'product.remove_from_cart',
}

export const ProductEventTrackingSchemas = {
  [ProductEventType.ProductAddToCart]: ProductAddToCartSchema,
  [ProductEventType.ProductRemoveFromCart]: ProductRemoveFromCartSchema,
} as const;
